import { IListCitiesRequest } from "../../../model/base/request/list-cities-request";
import { IListCityResponse } from "../../../model/base/response/list-city-response";
import { IListClientsResponse } from "../../../model/base/response/list-clients-response";
import { IListStateResponse } from "../../../model/base/response/list-state-response";
import { IAuthenticationRequest } from "../../../model/security/request/authentication-request";
import { IChangeUserPasswordRequest } from "../../../model/security/request/change-user-password-request";
import { IPreAuthenticationRequest } from "../../../model/security/request/pre-authentication-request";
import { IUpdateUserProfileRequest } from "../../../model/security/request/update-user-profile-request";
import { IAuthenticationResponse } from "../../../model/security/response/authentication-response";
import { IPreAuthenticationResponse } from "../../../model/security/response/pre-authentication-response";
import { IUserAuthenticatedResponse } from "../../../model/security/response/user-authenticated-response";
import { IUserProfileResponse } from "../../../model/security/response/user-profile-response";
import HttpClient from "../../services/http-client";
import ApplicationAppService from "../application-app-service";

const defaultPath = 'Authentication';

let applicationData = ApplicationAppService.getApplicationData();

var baseUrl = applicationData.securityUrl;

const preAuthentication = async (params?: IPreAuthenticationRequest): Promise<IPreAuthenticationResponse> => {

    return await HttpClient.executeRequest({
        method: 'post',
        data: params,
        baseURL: baseUrl,
        url: `/${defaultPath}/PreAuthentication`
    }).then((response) => Object.assign({} as IPreAuthenticationResponse, response.data));
};

const changePassword = async (params?: IChangeUserPasswordRequest) => {

    return await HttpClient.executeRequest({
        method: 'post',
        data: params,
        baseURL: baseUrl,
        url: `/${defaultPath}/UserProfile/ChangeUserPassword`
    });
};
const updateProfile = async (params?: IUpdateUserProfileRequest) => {

    return await HttpClient.executeRequest({
        method: 'post',
        data: params,
        baseURL: baseUrl,
        url: `/${defaultPath}/UserProfile/Update`
    });
};
const authentication = async (params?: IAuthenticationRequest) :  Promise<IAuthenticationResponse>  => {
  return  await HttpClient.executeRequest({
        method: 'post',
        data: params,
        baseURL: baseUrl,
        url: `/${defaultPath}/Authentication`
    })
        .then((response) => 
        Object.assign({} as IAuthenticationResponse, response.data)
   
        )
};
const getUserProfile = async (): Promise<IUserProfileResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/UserProfile`,
        baseURL: baseUrl
    }).then((response) => Object.assign({} as IUserProfileResponse, response.data));
};

const listStates = async (): Promise<IListStateResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/States`,
        baseURL: baseUrl
    }).then((response) => Object.assign([] as IListStateResponse[], response.data));
};
const listCities = async (params: IListCitiesRequest): Promise<IListCityResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/Cities`,
        params: params,
        baseURL: baseUrl
    }).then((response) => Object.assign([] as IListCityResponse[], response.data));
};
const isAuthenticated = async (): Promise<IUserAuthenticatedResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/IsAuthenticated`
    })
        .then((response) =>
            Object.assign({} as IUserAuthenticatedResponse, response.data)
        )
};

const listClients = async (clientId: number | undefined): Promise<IListClientsResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/Base/clients`,
        baseURL: baseUrl,
        params: { clientId }
    }).then((response) => Object.assign([] as unknown as IListClientsResponse, response.data));
};


const AuthenticatorAppService = {
    preAuthentication, authentication,changePassword, updateProfile, isAuthenticated, listClients,getUserProfile,listStates,listCities
};

export default AuthenticatorAppService;